import { Tables } from '../../../../../../modules/API/Tables/Tables'
import { ITableDataProvider } from '../../../../../../generic/universal-table/types/data-provider.types'
import { palletTableAdapter } from '../adapters/palletTable.adapter'
import {
  PalletCreatePayload,
  PalletUiRow,
  PalletUpdatePayload,
} from '../types/palletTable.types'

export const palletTableService: ITableDataProvider<
  PalletUiRow,
  PalletCreatePayload,
  PalletUpdatePayload
> = {
  getList: async (): Promise<PalletUiRow[]> => {
    const rows = await Tables.getPalletList()
    return rows.map(palletTableAdapter.fromApi)
  },

  create: async (payload: PalletCreatePayload): Promise<PalletUiRow> => {
    const created = await Tables.createPallet(payload)
    return palletTableAdapter.fromApi(created)
  },

  update: async (
    id: number | string,
    payload: PalletUpdatePayload
  ): Promise<PalletUiRow> => {
    const updated = await Tables.updatePallet(Number(id), payload)
    return palletTableAdapter.fromApi(updated)
  },

  remove: async (id: number | string): Promise<void> => {
    await Tables.deletePallet(Number(id))
  },
}
